webpackJsonp([1],{

/***/ "+J1d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/github_image.9abb0ba.png";

/***/ }),

/***/ "+X5K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Livio_Office_Map.e94589a.png";

/***/ }),

/***/ "/5YN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("ZdJ2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_749081e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("F+5G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_749081e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "27Aj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__ = __webpack_require__("/5YN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__ = __webpack_require__("kcv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    components: {
        "page-footer": __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__["a" /* default */],
        "page-header": __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__["a" /* default */],
        "side-nav": __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "2AKR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__ = __webpack_require__("/5YN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__ = __webpack_require__("kcv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        // This needs to be calculated because the operation can't be performed inline
        half_array_length: function half_array_length(array) {
            return Math.floor(array.length / 2);
        }
    },
    components: {
        "page-footer": __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__["a" /* default */],
        "page-header": __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__["a" /* default */],
        "side-nav": __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__["a" /* default */]
    },
    data: function data() {
        return {
            "years": [{
                "title": "2017",
                "has_booth": true,
                "header_text": "In 2017, as the SmartDeviceLink Consortium (SDLC) Project Maintainer, Livio demonstrated a few proofs of concept using SmartDeviceLink (SDL), alongside several SDLC members displaying their own SDL implementations. Our booth space consisted of a wrapped Ford F-150 and two custom bicycles to showcase our demos, with Ford, Toyota, Sygic, GNX, IBM, and Clarion sharing the booth space.",
                "demo_text": ["Our connected bicycle demonstrations showed how cyclists can access the content on their phones in a safe manner through a distraction-free interface similar to that found in SDL-enabled vehicles. With tablets and Raspberry Pis mounted on the bikes, riders could access their apps on the road and even play music through speakers on our custom beach cruiser trike.", "Ford and Toyota announced their collaboration in founding the SmartDeviceLink Consortium at CES 2017, and showcased their SDL implementations to demonstrate how the same product could be white-labeled and used to meet different goals and maintain brand awareness.", "Livio also demonstrated streaming video from a drone directly into the infotainment system using SDL. This would allow drivers to deploy and control drones from their vehicles while safely parked. The F150 was used to show the video in-vehicle and with an already in production head unit."],
                "summary": "Our presence at CES 2017 was a fun one. Through our demonstrations, we showcased the portability of SDL between different operating systems, hardware, and modes of transportation entirely. We used the software to control mobile applications by safer means in the F-150, bicycles, and tricycles. We also showed a concept involving a drone being deployed from a vehicle to serve as a bird's eye view of traffic."
            }, {
                "title": "2018",
                "has_booth": true,
                "header_text": "Livio returned to CES in 2018 to demonstrate new and innovative proofs of concept leveraging SmartDeviceLink (SDL), with the theme “Brought in, Beamed in, Built in.” Many SmartDeviceLink Consortium (SDLC) members and app partners, including Ford, Toyota, Amazon, Waze, Sygic, TomTom, Elektrobit, and Luxoft, also presented their SDL demos in the booth.",
                "demo_text": ["We showed how SDL can be used as an interface regardless of where an application resides, including using an onboard modem to beam in apps from the cloud and the ability to develop apps that are embedded (built) into the vehicle infotainment system, in addition to bringing in applications on a mobile device.", "Our demos consisted of a cloud-based ride-sharing fleet management platform, a built in and beamed in music player, and SDL’s remote control feature, which allows an application to control various safe modules in a vehicle. Combined these features allowed riders to request a ride, have their music playing when they entered, and have the climate controls set to their preference all using SDL."],
                "summary": "Livio's SDL demonstrations were well received at CES 2018. We showed our rideshare applications both inside the vehicle as well as on standalone pedestals, which served to highlight the flexibility and adaptability of our solution. Livio’s demos, alongside various hardware and exciting demonstrations from SDLC members and partners, made the booth a popular one on the show floor."
            }, {
                "title": "2019",
                "has_booth": true,
                "header_text": "We focused on in-vehicle ordering and fleet management for a logistics company using SmartDeviceLink (SDL) capabilities for our demonstrations at CES 2019 and wowed attendees with our wrapped Lincoln MKC. Toyota, Ford, Amazon, Subaru, Luxoft, Xevo, Sygic, and Garmin also shared their SDL demonstrations on behalf of the SmartDeviceLink Consortium (SDLC) and brought lots of traffic to the booth.",
                "demo_text": ["Our SDL demonstrations consisted of two separate use cases each having their own unique application. One was for ordering coffee and the second was a platform for drivers to manage delivering packages. We showcased how drivers, riders, and businesses could navigate and excel at managing goods and services using SDL.", "Livio also had the opportunity to showcase Livio Music, a media player that combines Apple Music, iTunes music, local music, and podcasts into one app. With its SDL integration, Livio Music was a great addition to the in-vehicle demonstrations."],
                "summary": "Livio's presence at CES 2019 was one of the best. We dedicated the largest portion of the booth to date to allowing SDLC members the opportunity to show Las Vegas what they built with SDL. Our in-vehicle demos were a hit too, drawing crowds of people in to learn about our software."
            }, {
                "title": "2020",
                "has_booth": false,
                "header_text": "",
                "demo_text": ["We demonstrated a variety of SmartDeviceLink (SDL) features at CES 2020 and did so on a wrapped Lincoln Aviator. Even more SDL features and use cases were demonstrated by SmartDeviceLink Consortium (SDLC) members in the booth: Ford, Sygic, Toyota, Suzuki, Luxoft, Xevo, Line, and Garmin.", "The three SDL features highlighted in Livio's demos were App Services, Custom Templates, and Cloud Applications. We showed how SDL can be leveraged by apps to create a more tailored experience within the vehicle for their brand, and presented a proof of concept vehicle rental system, which utilized both cloud application and media capabilities of SDL."],
                "summary": "CES attendees were very excited and interested to see what Livio and SDLC members had to share at CES 2020. We saw strong interest in our demonstrations and enjoyed sharing our vision for the future of in-vehicle applications and advancing the customer's in-vehicle experience using SDL."
            }, {
                "title": "2022",
                "has_booth": false,
                "header_text": "Livio represented the SmartDeviceLink Consortium (SDLC) at CES 2022 and maintained the booth and demonstrations on the consortium's behalf. The show allowed Livio to share many of the new developments in SmartDeviceLink (SDL) since 2020, including the potential to port SDL to the Android Automotive OS.",
                "demo_text": ["We showed how it's possible to enable SDL in an In-Vehicle-Infotainment (IVI) system running Android Automotive OS, and included SDL Core and a complimentary HMI in our demo. With the growing adoption of Android Automotive OS for IVI systems, this demo was especially enticing to both app developers and automotive manufacturers.", "SDL's robust ability to connect from anywhere was exemplified in our Embedded Android Applications demo, which showed how SDL-enabled applications could be installed directly on the IVI and leverage SDL to be used in a known, driver distraction-free way without the developer needing to modify their app. We also shared the SDL Capabilities App, a reference application that can be used to test SDL systems and HMIs, and demonstrates many of the features and components of SDL that can be referenced by developers."],
                "summary": "CES 2022 gave Livio and the SDLC the opportunity to show the relevance, adaptability, and potential SDL can hold in the ever-changing world of In-Vehicle-Infotainment. The demonstrations showed that SDL can be a powerful resource for advancing the in-vehicle experience for customers and allowing app developers and automotive manufacturers to connect with customers on a new level."
            }]
        };
    }
});

/***/ }),

/***/ "4pAi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/skyline@2x.cb849dd.png";

/***/ }),

/***/ "4wmx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lmp_image.f99edc0.png";

/***/ }),

/***/ "6+Jj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "98xr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("u5xo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ba14bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("auSy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ba14bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9nCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page page-ces d-flex",attrs:{"id":"ces"}},[_c('page-header',{staticClass:"ces-header"}),_vm._v(" "),_c('side-nav',{staticClass:"ces-side-nav"}),_vm._v(" "),_c('div',{staticClass:"w-100 ces-content"},[_c('p',{staticClass:"ces-main"},[_vm._v("The Consumer Electronics Show is part of the Livio culture. For many years now, we have taken to the show floor to demonstrate new and creative ways to show off our project, SmartDeviceLink.  In the past, we’ve showcased solutions for fleet management, logistics, food service, vehicle rental, and also tricycles.")]),_vm._v(" "),_c('b-tabs',{staticClass:"ces-tabs",attrs:{"content-class":"mt-3","justified":""}},_vm._l((_vm.years),function(year){return _c('div',[_c('b-tab',{staticClass:"w-100",attrs:{"title":year.title,"active":""}},[_c('img',{staticClass:"w-100",attrs:{"src":("../../static/images/CES/" + (year.title) + "/" + (year.title) + "_Header.jpg")}}),_vm._v(" "),_c('h4',{staticClass:"liviomono ces-year w-100"},[_vm._v("Livio's "+_vm._s(year.title)+" CES Demo")]),_vm._v(" "),_c('p',{staticClass:"livionorm ces-about-year w-100"},[_vm._v(_vm._s(year.header_text))]),_vm._v(" "),_c('div',{staticClass:"ces-container d-lg-none"},_vm._l((year.demo_text.length),function(index){return _c('div',{key:index},[_c('b-row',{staticClass:"ces-row"},[_c('img',{staticClass:"w-100",attrs:{"src":("../../static/images/CES/" + (year.title) + "/" + (year.title) + "_Demo" + index + ".jpg")}}),_vm._v(" "),_c('p',{staticClass:"livionorm ces-demo"},[_vm._v(_vm._s(year.demo_text[index - 1]))])])],1)}),0),_vm._v(" "),_c('div',{staticClass:"ces-container d-none d-lg-block"},_vm._l((_vm.half_array_length(year.demo_text)),function(index){return _c('div',{key:index},[((index + 1) * 2 > year.demo_text.length)?_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"ces-left"},[_c('img',{staticClass:"w-100",attrs:{"src":("../../static/images/CES/" + (year.title) + "/" + (year.title) + "_Demo" + ((index - 1) * 2 + 1) + ".jpg")}}),_vm._v(" "),_c('p',{staticClass:"livionorm ces-demo"},[_vm._v(_vm._s(year.demo_text[(index - 1) * 2]))])]),_vm._v(" "),_c('b-col',{staticClass:"ces-right"},[_c('img',{staticClass:"w-100",attrs:{"src":("../../static/images/CES/" + (year.title) + "/" + (year.title) + "_Demo" + ((index - 1) * 2 + 2) + ".jpg")}}),_vm._v(" "),_c('p',{staticClass:"livionorm ces-demo"},[_vm._v(_vm._s(year.demo_text[(index - 1) * 2 + 1]))])])],1):_vm._e(),_vm._v(" "),((index * 2) + 1 === year.demo_text.length)?_c('b-row',[_c('b-col',{staticClass:"ces-left"},[_c('img',{staticClass:"w-100",attrs:{"src":("../../static/images/CES/" + (year.title) + "/" + (year.title) + "_Demo" + (year.demo_text.length) + ".jpg")}})]),_vm._v(" "),_c('b-col',{staticClass:"ces-text-right align-items-left"},[_c('p',{staticClass:"livionorm ces-demo ces-last-right"},[_vm._v(_vm._s(year.demo_text[year.demo_text.length - 1]))])])],1):_vm._e()],1)}),0),_vm._v(" "),_c('h4',{staticClass:"liviomono ces-summary-mono"},[_vm._v("Summary")]),_vm._v(" "),_c('p',{staticClass:"livionorm ces-summary-norm"},[_vm._v(_vm._s(year.summary))])])],1)}),0)],1)],1),_vm._v(" "),_c('page-footer',{staticClass:"d-md-none ces-footer"}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-md-block footer"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"ces-footer-container container"},[_c('div',{staticClass:"row align-items-top"},[_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("1.248.591.0333")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"mailto:info@livio.io"}},[_vm._v("info@livio.io")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("332 E Lincoln Ave.")]),_vm._v(" "),_c('p',[_vm._v("Royal Oak, MI 48067")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("© 2022 Livio. All rights reserved.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9nMd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AkBr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Livio_Office_Map_small.16631a6.png";

/***/ }),

/***/ "B3Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__ = __webpack_require__("/5YN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__ = __webpack_require__("kcv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    components: {
        "page-footer": __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__["a" /* default */],
        "page-header": __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__["a" /* default */],
        "side-nav": __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "BA9K":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "C1un":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sdl_logo@3x.97e1b7b.png";

/***/ }),

/***/ "F+5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-top justify-content-md-center"},[_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("1.248.591.0333")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"mailto:info@livio.io"}},[_vm._v("info@livio.io")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("332 E Lincoln Ave.")]),_vm._v(" "),_c('p',[_vm._v("Royal Oak, MI 48067")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("© 2022 Livio. All rights reserved.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__ = __webpack_require__("/5YN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__ = __webpack_require__("kcv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    components: {
        "page-footer": __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__["a" /* default */],
        "page-header": __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__["a" /* default */],
        "side-nav": __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "HHhG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lmp_image@2x.8f1f038.png";

/***/ }),

/***/ "HMAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-master"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jie2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page page-office d-flex",attrs:{"id":"office"}},[_c('page-header',{staticClass:"office-header"}),_vm._v(" "),_c('side-nav',{staticClass:"office-side-nav"}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"d-none d-sm-block d-md-none office-spacer"}),_vm._v(" "),_c('page-footer',{staticClass:"d-md-none small-office-footer"}),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 office-content"},[_c('div',{staticClass:"d-none d-md-block office-map"},[_c('img',{staticClass:"bitmap",attrs:{"src":__webpack_require__("+X5K")}}),_vm._v(" "),_c('img',{staticClass:"office-focus",attrs:{"src":__webpack_require__("vkn1")}})]),_vm._v(" "),_c('div',{staticClass:"col-12 d-md-none d-sm-block d-xs-none small-office-map"},[_c('img',{staticClass:"small-bitmap w-100 highlight",attrs:{"src":__webpack_require__("AkBr")}}),_vm._v(" "),_c('img',{staticClass:"small-office-focus",attrs:{"src":__webpack_require__("vkn1")}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-md-block office-footer footer"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"office-footer-container container"},[_c('div',{staticClass:"row align-items-top"},[_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("1.248.591.0333")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"mailto:info@livio.io"}},[_vm._v("info@livio.io")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("332 E Lincoln Ave.")]),_vm._v(" "),_c('p',[_vm._v("Royal Oak, MI 48067")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left mb-4"},[_c('p',[_vm._v("© 2022 Livio. All rights reserved.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467cbf74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("HMAn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467cbf74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MKuP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/github_image@2x.3a98110.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_css_font_awesome_min_css__ = __webpack_require__("Qq5Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_css_style_css__ = __webpack_require__("rqsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_scrollactive__ = __webpack_require__("nnCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_scrollactive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_scrollactive__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_scrollactive___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */], VueScrollactive: __WEBPACK_IMPORTED_MODULE_8_vue_scrollactive___default.a }
});

/***/ }),

/***/ "NIPM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Careers_vue__ = __webpack_require__("Tsr6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63261ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Careers_vue__ = __webpack_require__("TptS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Careers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63261ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Careers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OliJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio-team-caree col d-none d-md-block sidebar"},[_c('div',[_c('ul',{staticClass:"side-nav-list"},[_c('router-link',{attrs:{"to":"/portfolio"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/portfolio"}},[_vm._v("Portfolio")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/team"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/team"}},[_vm._v("Team")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/careers"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/careers"}},[_vm._v("Careers")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/ces"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/ces"}},[_vm._v("CES")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/office"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/office"}},[_vm._v("Office")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QXtr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lmp_logo@2x.fdd8ded.png";

/***/ }),

/***/ "Qq5Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TptS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page page-careers d-flex",attrs:{"id":"careers"}},[_c('page-header',{staticClass:"careers-header"}),_vm._v(" "),_c('side-nav',{staticClass:"careers-side-nav"}),_vm._v(" "),_c('div',{staticClass:"row align-items-end w-100 no-gutters"},[_c('div',{staticClass:"d-none d-md-block col-10 col-sm-6 offset-1 offset-sm-3"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"why"},[_vm._v("We're a small office with a startup culture, and at the same time, have all the benefits of being a wholly-owned subsidiary of Ford Motor Co.")]),_vm._v(" "),_c('p',{staticClass:"why"},[_vm._v("Flexible hours, health, dental, vision, Ford Retirement Plan, and 401K.")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center justify-content-center d-flex w-100 careers"},_vm._l((_vm.careers),function(career){return _c('a',{staticClass:"card-career",attrs:{"href":career.url,"target":"_blank"}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(career.title)+" - "+_vm._s(career.subtext))]),_vm._v(" "),_vm._l((career.requirements),function(requirement){return _c('span',{staticClass:"requirement"},[_vm._v(_vm._s(requirement))])})],2)}),0),_vm._v(" "),(_vm.careers.length === 0)?_c('div',{staticClass:"why no-available-positions"},[_vm._v("Please check back for available positions.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-md-none d-sm-block why-block"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"why"},[_vm._v("We're a small office with a startup culture, and at the same time, have all the benefits of being a wholly-owned subsidiary of Ford Motor Co.")]),_vm._v(" "),_c('p',{staticClass:"why"},[_vm._v("Flexible hours, health, dental, vision, Ford Retirement Plan, and 401K.")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center justify-content-center d-flex w-100 careers"},_vm._l((_vm.careers),function(career){return _c('a',{staticClass:"card-career",attrs:{"href":career.url,"target":"_blank"}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(career.title)+" - "+_vm._s(career.subtext))]),_vm._v(" "),_vm._l((career.requirements),function(requirement){return _c('span',{staticClass:"requirement"},[_vm._v(_vm._s(requirement))])})],2)}),0),_vm._v(" "),(_vm.careers.length === 0)?_c('div',{staticClass:"why no-available-positions"},[_vm._v("Please check back for available positions.")]):_vm._e()]),_vm._v(" "),_vm._m(2)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"why why-work-at-livio-w"},[_c('b',[_c('h1',[_vm._v("Why work at Livio?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"why why-work-at-livio-w"},[_c('b',[_c('h1',[_vm._v("Why work at Livio?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offset-1 col-10"},[_c('div',{staticClass:"align-items-bottom justify-content-between text-center d-flex w-100 team"},[_c('img',{staticClass:"livio-illustration",attrs:{"src":__webpack_require__("o0dx"),"srcset":__webpack_require__("4pAi") + " 2x, " + __webpack_require__("lfIn") + " 3x"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tsr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__ = __webpack_require__("/5YN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__ = __webpack_require__("kcv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            /**
             * careers - An array of JSON objects with details on a position
             * 
             * JSON fields:
             * title - ex. Mobile Software Engineer
             * subtext - The respective team (ex. iOS)
             * requirements - Relevant programming languages (ex. Swift, Swift UI, Objective-C)
             * url - Ford link to the application
             */
            "careers": []
        };
    },

    components: {
        "page-footer": __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__["a" /* default */],
        "page-header": __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__["a" /* default */],
        "side-nav": __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "X2FP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Careers__ = __webpack_require__("NIPM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CES__ = __webpack_require__("rLlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Office__ = __webpack_require__("gbdj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Portfolio__ = __webpack_require__("yRJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Team__ = __webpack_require__("m9ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_Header__ = __webpack_require__("9bIQ");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: "history",
    routes: [{
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
    }, {
        path: '/careers',
        name: 'Careers',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Careers__["a" /* default */]
    }, {
        path: '/ces',
        name: 'CES',
        component: __WEBPACK_IMPORTED_MODULE_4__components_CES__["a" /* default */]
    }, {
        path: '/office',
        name: 'Office',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Office__["a" /* default */]
    }, {
        path: '/portfolio',
        name: 'Portfolio',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Portfolio__["a" /* default */]
    }, {
        path: '/team',
        name: 'Team',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Team__["a" /* default */]
    }, {
        path: '/header',
        name: 'Header',
        component: __WEBPACK_IMPORTED_MODULE_8__components_shared_Header__["a" /* default */]
    }, {
        path: '*',
        redirect: '/'
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
}));

/***/ }),

/***/ "ZdJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ "auSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-100 header-min"},[_c('div',{staticClass:"row align-items-end no-gutters"},[(!_vm.isHidden)?_c('div',{staticClass:"d-sm-flex d-md-none header-background"}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col no-gutters d-none d-sm-block between"}),_vm._v(" "),_c('div',{staticClass:"col d-xs-flex d-sm-none header-spacer"}),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.isHidden)?_c('button',{staticClass:"d-sm-flex d-md-none header-open-dropdown",on:{"click":function($event){_vm.isHidden=!_vm.isHidden}}},[_c('a',{staticClass:"fa fa-chevron-down fa-2x livio-blue",staticStyle:{"color":"#49C7ED"}})]):_vm._e(),_vm._v(" "),(!_vm.isHidden)?_c('button',{staticClass:"d-sm-flex d-md-none header-close-dropdown",on:{"click":function($event){_vm.isHidden=!_vm.isHidden}}},[_c('a',{staticClass:"fa fa-chevron-up fa-2x livio-blue",staticStyle:{"color":"#49C7ED"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"navbar-collapse d-lg-none d-xl-block"},[(!_vm.isHidden)?_c('ul',{staticClass:"d-md-none nav nav-pills flex-column d-md-none w-100 header-dropdown"},[_c('router-link',{attrs:{"to":"/portfolio"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/portfolio"}},[_vm._v("Portfolio")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/team"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/team"}},[_vm._v("Team")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/careers"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/careers"}},[_vm._v("Careers")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/ces"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/ces"}},[_vm._v("CES")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/office"}},[_c('a',{staticClass:"portfolio-team-caree",attrs:{"href":"/office"}},[_vm._v("Office")])])],1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/"}},[_c('div',{},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("dc23"),"srcset":__webpack_require__("6+Jj") + " 2x, " + __webpack_require__("cYlU") + " 3x"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-gutters d-none d-md-inline-block"},[_c('div',{staticClass:"rectangle"},[_c('div',{staticClass:"code-coffee-create"},[_vm._v("\n                    Code. Coffee. Create.\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bMYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative portfolio-min-height"},[_c('page-header',{staticClass:"portfolio-header"}),_vm._v(" "),_c('side-nav',{staticClass:"portfolio-side-nav"}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-highlights d-flex",attrs:{"id":"highlights"}},[_c('div',{staticClass:"row align-items-center text-center w-100 no-gutters"},[_c('a',{staticClass:"col-12 col-md-4 sdl",attrs:{"href":"https://smartdevicelink.com","target":"_blank"}},[_c('img',{staticClass:"highlight portfolio-min-height",attrs:{"src":__webpack_require__("iWRB"),"srcset":__webpack_require__("vVcJ") + " 2x, " + __webpack_require__("sfbs") + " 3x"}}),_vm._v(" "),_c('img',{staticClass:"focus",attrs:{"src":__webpack_require__("9nMd"),"srcset":__webpack_require__("vm5F") + " 2x, " + __webpack_require__("C1un") + " 3x"}})]),_vm._v(" "),_c('a',{staticClass:"col-12 col-md-4 liviomusic",attrs:{"href":"https://music.livio.io","target":"_blank"}},[_c('img',{staticClass:"highlight portfolio-min-height",attrs:{"src":__webpack_require__("4wmx"),"srcset":__webpack_require__("HHhG") + " 2x, " + __webpack_require__("xKYY") + " 3x"}}),_vm._v(" "),_c('img',{staticClass:"focus",attrs:{"src":__webpack_require__("98xr"),"srcset":__webpack_require__("QXtr") + " 2x, " + __webpack_require__("s8rT") + " 3x"}})]),_vm._v(" "),_c('a',{staticClass:"col-12 col-md-4 github",attrs:{"href":"https://github.com/smartdevicelink","target":"_blank"}},[_c('img',{staticClass:"highlight portfolio-min-height",attrs:{"src":__webpack_require__("+J1d"),"srcset":__webpack_require__("MKuP") + " 2x, " + __webpack_require__("zk6p") + " 3x"}}),_vm._v(" "),_c('img',{staticClass:"focus",attrs:{"src":__webpack_require__("BA9K"),"srcset":__webpack_require__("X2FP") + " 2x, " + __webpack_require__("kqII") + " 3x"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cYlU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dc23":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dvr2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page page-team d-flex",attrs:{"id":"team"}},[_c('page-header',{staticClass:"top team-header"}),_vm._v(" "),_c('side-nav'),_vm._v(" "),_c('div',{staticClass:"row align-items-left w-100 no-gutters"},[_c('div',{staticClass:"team-top"},[_c('div',{staticClass:"row align-items-top justify-content-md-start justify-content-center text-left d-flex team-list"},_vm._l((_vm.team),function(member){return _c('div',{staticClass:"card-team text-left"},[_c('p',{staticClass:"name liviomono"},[_vm._v(_vm._s(member.name))]),_vm._v(" "),_c('p',{staticClass:"role"},[_vm._v(_vm._s(member.role))]),_vm._v(" "),_c('p',{staticClass:"subtext"},[_vm._v(_vm._s(member.subtext))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"w-100"}),_vm._v(" "),_vm._m(0)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offset-1 col-10"},[_c('div',{staticClass:"row align-items-bottom justify-content-between text-center d-flex w-100 team"},[_c('img',{staticClass:"livio-illustration",attrs:{"src":__webpack_require__("o0dx"),"srcset":__webpack_require__("4pAi") + " 2x, " + __webpack_require__("lfIn") + " 3x"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f7ns":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            "isHidden": true
        };
    }
});

/***/ }),

/***/ "gbdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Office_vue__ = __webpack_require__("27Aj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d396ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Office_vue__ = __webpack_require__("Jie2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Office_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d396ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Office_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iWRB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sdl_image.efc1f3b.png";

/***/ }),

/***/ "kcv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNav_vue__ = __webpack_require__("f7ns");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98131cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNav_vue__ = __webpack_require__("OliJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98131cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kqII":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gh_logo@3x.7287812.png";

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22486b40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("nfjV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22486b40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfIn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/skyline@3x.e46c9d7.png";

/***/ }),

/***/ "m9ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__("wvXx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15eec79e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__("dvr2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15eec79e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nfjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"page page-intro d-flex",attrs:{"id":"highlights"}},[_c('page-header',{staticClass:"home-header"}),_vm._v(" "),_c('side-nav',{staticClass:"home-sidebar"}),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center h-100 w-100"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"row align-items-center w-100 no-gutters"},[_c('div',{staticClass:"col-10 col-sm-6 offset-1 offset-sm-3"},[_c('div',{staticClass:"about"},[_c('p',{staticClass:"title liviomono home-title"},[_vm._v("An emerging leader in automotive technology.")]),_vm._v(" "),_c('p',{staticClass:"subtext livionorm home-subtext"},[_vm._v("We’re a team of engineers, developers, project managers, and creators. We are the project maintainer of SmartDeviceLink and a subsidiary of Ford, actively contributing to projects within Connected Vehicle Platform & Products.")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o0dx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/skyline.c045baf.png";

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLlG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CES_vue__ = __webpack_require__("2AKR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39334c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CES_vue__ = __webpack_require__("9nCU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CES_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39334c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CES_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rqsT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s8rT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lmp_logo@3x.15dc96f.png";

/***/ }),

/***/ "sfbs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sdl_image@3x.d8182d3.png";

/***/ }),

/***/ "u5xo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isHidden: true
        };
    }
});

/***/ }),

/***/ "vVcJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sdl_image@2x.8bfd447.png";

/***/ }),

/***/ "vkn1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/our-office.a582ecf.png";

/***/ }),

/***/ "vm5F":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wvXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__ = __webpack_require__("/5YN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__ = __webpack_require__("kcv/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            "team": [{
                "name": "Paul Elsila",
                "role": "Chief Executive Officer",
                "subtext": null
            }, {
                "name": "Joey Grover",
                "role": "Chief Technology Officer",
                "subtext": null
            }, {
                "name": "Chris Rokita",
                "role": "Software Engineer",
                "subtext": "Quick Tips"
            }, {
                "name": "Jacob Keeler",
                "role": "Software Engineer",
                "subtext": "User Profiles"
            }, {
                "name": "Jordyn Mackool",
                "role": "Program Manager",
                "subtext": null
            }, {
                "name": "Shobhit Adlakha",
                "role": "Software Engineer",
                "subtext": "User Profiles"
            }, {
                "name": "Nick Reno",
                "role": "Software Engineer",
                "subtext": "Quick Tips"
            }, {
                "name": "Julian Kast",
                "role": "Software Engineer",
                "subtext": "Quick Tips"
            }, {
                "name": "Chloe Matthews",
                "role": "Software Engineer",
                "subtext": "Zoom"
            }, {
                "name": "Justin Beharry",
                "role": "Software Engineer",
                "subtext": "User Profiles"
            }, {
                "name": "Jacob Rau",
                "role": "Software Engineer",
                "subtext": "User Profiles"
            }, {
                "name": "Surya Sagiraju",
                "role": "Software Engineer",
                "subtext": "Quick Tips"
            }, {
                "name": "Ty Strayer",
                "role": "Software Engineer",
                "subtext": "User Profiles"
            }, {
                "name": "Brandon Garrison",
                "role": "Software Engineer",
                "subtext": "Zoom"
            }, {
                "name": "Eric Horlocker",
                "role": "Software Engineer",
                "subtext": "Zoom"
            }]
        };
    },

    components: {
        "page-footer": __WEBPACK_IMPORTED_MODULE_1__shared_Footer_vue__["a" /* default */],
        "page-header": __WEBPACK_IMPORTED_MODULE_0__shared_Header_vue__["a" /* default */],
        "side-nav": __WEBPACK_IMPORTED_MODULE_2__shared_SideNav_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xKYY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lmp_image@3x.05cea68.png";

/***/ }),

/***/ "yRJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__ = __webpack_require__("B3Kk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2b8b51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__ = __webpack_require__("bMYf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2b8b51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zk6p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/github_image@3x.6196ce9.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6ffc9cc1c3e95fccfd94.js